export interface Subject {
  courseName: string
  description: string
  id: string
  parentId: string
  status: 'ACTIVE' | ''
}

export interface Material {
  description: string
  courseName: string
  status: 'ACTIVE' | ''
  filePath: string
  materialType: string
  orderSequence: string
  title: string
}

export interface TopicInfo {
  topic: {
    description: string
    courseName: string
    status: 'ACTIVE' | ''
    createdAt: number
  }
  materialList: Array<Material>
}

export interface Chapter {
  courseName: string
  createdAt: number
  description: string
  id: string
  parentId: string
  parentName: null
  status: 'ACTIVE' | ''
  updatedAt: number
  videoCount: string
  topicMaterialResponses: Array<TopicInfo>
}

export interface ChaptersInfo {
  subjectName?: string
  list?: Array<Chapter>
  selectedChapter?: string
  selectedTopic?: TopicInfo | null
  selectedMaterial?: Material
}

// Define a type for the slice state
interface SubjectState {
  isLoading: boolean
  subjects: Array<Subject>
  chapters: ChaptersInfo
  batchId: string
  hasError?: boolean
}

// Define the initial state using that type
export const initialState: SubjectState = {
  isLoading: false,
  subjects: [],
  chapters: {},
  batchId: '',
  hasError: false
}

export interface GetChaptersOptions {
  subjectId: string
  subjectName: string
  batchId: string
}

export interface GetSubjectsOptions {
  courseId: string
  batchId: string
}

export interface GetSubjectsResponse {
  subjects: Array<Subject>
  batchId: string
}
